import { Link } from "react-router-dom";
import LandingNav from "@/pages/home/components/LandingNav";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0A0B0F] text-white font-sans">
      <LandingNav />

      <section className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-[#C8A96E] text-xs font-semibold uppercase tracking-widest mb-3">Legal</p>
          <h1 className="text-4xl md:text-5xl font-black mb-4">Terms of Service</h1>
          <p className="text-white/40 text-sm mb-12">Last updated: May 20, 2026 · Version 2.4</p>

          <div className="space-y-10 text-white/70 text-sm leading-relaxed">
            <div>
              <h2 className="text-white font-bold text-base mb-3">1. Acceptance of Terms</h2>
              <p className="mb-3">
                By creating an account or using Pixory AI (&ldquo;the Service&rdquo;), you agree to be bound by these Terms of Service. If you are using the Service on behalf of a photography studio, business, or organization, you represent that you have the authority to bind that entity to these terms.
              </p>
              <p>
                We reserve the right to update these terms at any time. Material changes will be communicated via email and in-app notification at least 15 days before taking effect. Continued use of the Service after changes constitutes acceptance of the updated terms.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">2. Account Registration</h2>
              <p className="mb-3">
                You must provide accurate, complete, and current information when creating your account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Notify us immediately at security@pixory.ai of any unauthorized access.
              </p>
              <p>
                Each account is intended for use by a single photography studio or business entity. Sharing login credentials across multiple unrelated businesses is prohibited. Multi-user access within a single studio is supported through our team features at the appropriate plan tier.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">3. Service Description</h2>
              <p className="mb-3">
                Pixory AI provides a business management platform for photography studios, including client relationship management, digital contract generation and e-signatures, payment tracking, job workflow automation, digital invitations with RSVP, photo selection and delivery, media package management, and client portal access.
              </p>
              <p>
                Features and functionality vary by subscription plan. We strive to maintain 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance is announced at least 48 hours in advance through our status page and in-app notifications.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">4. Subscriptions &amp; Payments</h2>
              <p className="mb-3">
                Subscription fees are billed monthly or annually based on your selected plan. All fees are non-refundable except as required by applicable law. You may upgrade or downgrade your plan at any time; downgrades take effect at the start of the next billing cycle.
              </p>
              <p className="mb-3">
                We reserve the right to modify pricing with 30 days notice. Price changes do not affect your current billing period. If you do not agree with updated pricing, you may cancel your subscription before the change takes effect.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">5. Acceptable Use</h2>
              <p className="mb-3">
                You agree not to use the Service for any unlawful purpose or in violation of any applicable laws. You may not upload, store, or transmit content that is illegal, infringing, defamatory, or that violates the rights of any third party.
              </p>
              <p className="mb-3">
                You retain all rights to photographs, designs, and creative content uploaded to Pixory AI. By uploading content, you grant us a limited license solely to store, display, and deliver that content as part of providing the Service to you and your designated clients.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">6. Client Portals &amp; Data Sharing</h2>
              <p className="mb-3">
                When you share client portals, digital invitations, photo galleries, or contract links, you are responsible for ensuring you have the necessary permissions from the recipients. Pixory AI provides the technical infrastructure; you control who receives access.
              </p>
              <p>
                We do not independently verify the identity of portal visitors or invitation recipients. We recommend using password protection and expiration dates for sensitive deliveries, features available within the platform.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">7. Limitation of Liability</h2>
              <p className="mb-3">
                Pixory AI is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis. To the fullest extent permitted by law, Pixory AI disclaims all warranties, express or implied. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.
              </p>
              <p>
                Our total liability for any claim arising from these terms or the Service is limited to the amount you paid us in the twelve months preceding the claim. This limitation applies regardless of the legal theory on which the claim is based.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">8. Termination</h2>
              <p className="mb-3">
                You may cancel your account at any time through your account settings. Upon cancellation, your data is retained for 30 days to allow you to export or reactivate. After this period, your data is permanently deleted from our active systems.
              </p>
              <p className="mb-3">
                We reserve the right to suspend or terminate accounts that violate these terms, with notice provided where reasonably possible. In cases of egregious violations such as illegal content hosting or platform abuse, immediate termination without prior notice may apply.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">9. Governing Law</h2>
              <p>
                These terms are governed by the laws of the State of Delaware, United States. Any disputes arising from these terms shall be resolved through binding arbitration in Dover, Delaware, in accordance with the rules of the American Arbitration Association.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-white/5 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-white/30 hover:text-white/60 text-xs transition-colors">← Back to Pixory AI</Link>
          <span className="text-white/20 text-xs">© 2025 Pixory AI. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}